import { api } from '../../../../components/common';
import { 
  Expense,
  ExpenseWithDetails,
  CreateExpenseRequest,
  UpdateExpenseRequest,
  ExpenseSearchParams,
  ExpenseListResponse,
  ExpenseImportResult
} from '../types';

export const expensesApi = {
  getAll: (params: ExpenseSearchParams = {}): Promise<ExpenseListResponse> => {
    // Build query params manually using URLSearchParams to properly serialize sorts array
    const queryParams = new URLSearchParams();
    
    if (params.search) queryParams.append('search', params.search);
    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());
    
    // Handle multiple sorts - encode as JSON string
    if (params.sorts && params.sorts.length > 0) {
      queryParams.append('sorts', JSON.stringify(params.sorts));
    }
    
    // Handle multiple search fields - encode as JSON string
    if (params.fields && params.fields.length > 0) {
      queryParams.append('fields', JSON.stringify(params.fields));
    }
    
    return api.get(`/expenses?${queryParams.toString()}`).then(res => res.data);
  },
    
  getById: (id: number): Promise<ExpenseWithDetails> =>
    api.get(`/expenses/${id}`).then(res => res.data),
    
  create: (expense: CreateExpenseRequest): Promise<Expense> =>
    api.post('/expenses', expense).then(res => res.data),
    
  update: (id: number, expense: UpdateExpenseRequest): Promise<Expense> =>
    api.put(`/expenses/${id}`, expense).then(res => res.data),
    
  delete: (id: number): Promise<void> =>
    api.delete(`/expenses/${id}`).then(() => {}),

  importCsv: (file: File): Promise<ExpenseImportResult> => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/expenses/import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => res.data);
  }
};


